// extracted by mini-css-extract-plugin
export default {"icon":"account-icon_icon__D+XtB"};